import React from "react";

function CloseX() {
  return (
    <>
      <svg
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.0002 0C8.79486 0 5.78148 1.24822 3.515 3.51469C-1.16383 8.19345 -1.16383 15.8064 3.51486 20.4852C5.78133 22.7518 8.79486 24 12.0002 24C15.2055 24 18.219 22.7518 20.4855 20.4852C25.1643 15.8064 25.1643 8.19345 20.4855 3.51469C18.219 1.24822 15.2055 0 12.0002 0ZM17.3999 17.3996C17.1869 17.6127 16.9077 17.7192 16.6285 17.7192C16.3494 17.7192 16.0701 17.6127 15.8573 17.3996L12.0002 13.5428L8.1433 17.3997C7.9302 17.6127 7.65108 17.7193 7.37188 17.7193C7.09275 17.7193 6.81348 17.6127 6.6006 17.3997C6.17449 16.9737 6.17449 16.283 6.6006 15.8569L10.4575 12L6.60053 8.14305C6.17442 7.71709 6.17442 7.02633 6.60053 6.60029C7.02649 6.17433 7.71726 6.17433 8.1433 6.60029L12.0002 10.4572L15.857 6.60029C16.283 6.17433 16.9738 6.17433 17.3998 6.60029C17.8259 7.02625 17.8259 7.71702 17.3998 8.14305L13.543 12L17.3999 15.8569C17.826 16.2829 17.826 16.9737 17.3999 17.3996Z"
          fill="#F1F1F1"
        />
      </svg>
    </>
  );
}

export { CloseX };
